import React from 'react'
import { useTranslation } from 'translation'

function Languages() {
  const { locale, setLocale } = useTranslation()

  const handleClick = (value) => {
    setLocale(value)
  }

  return (
    <div className='tw-relative tw-flex tw-items-center tw-bg-gray-100 tw-rounded-full tw-p-1 tw-w-[80px] tw-cursor-pointer tw-border tw-border-gray-200'>
      {/* Highlighted slider */}
      <div
        className={`tw-absolute tw-top-1 tw-bottom-1 tw-w-[38px] tw-rounded-full tw-bg-white tw-shadow-md tw-transition-all tw-duration-300 ${
          locale === 'en' ? 'tw-left-1' : 'tw-left-[39px]'
        }`}
      ></div>

      {/* EN */}
      <span
        onClick={() => handleClick('en')}
        className={`tw-flex-1 tw-text-center tw-text-sm tw-font-medium tw-z-10 transition-colors ${
          locale === 'en' ? 'tw-text-blue-600' : 'tw-text-gray-500'
        }`}
      >
        EN
      </span>

      {/* AR */}
      <span
        onClick={() => handleClick('ar')}
        className={`tw-flex-1 tw-text-center tw-text-sm tw-font-medium tw-z-10 transition-colors ${
          locale === 'ar' ? 'tw-text-blue-600' : 'tw-text-gray-500'
        }`}
      >
        ع
      </span>
    </div>
  )
}

export default Languages
